import { Action } from "vuex-class-modules";
import AxiosSecureModule from "./axiosSecureModule";
import Axios, { AxiosResponse } from "axios";
import { Log } from "@/plugins/Logging";
import MobEmergencySettingsViewModel from "@/models/MobEmergencySettingsViewModel";
export default class MobModule extends AxiosSecureModule {
    @Action
    public async getEmergencySettings(): Promise<MobEmergencySettingsViewModel> {
        await this.defineHeaderAxios();
        const result = await Axios.get<MobEmergencySettingsViewModel>("api/mob/settings");
        if (result.status !== 200 || !result.data) {
            throw new Error("Unable to load MOB emergency settings.");
        }
        return result.data;
    }

    @Action
    public async updateEmergencySettings(settings: MobEmergencySettingsViewModel): Promise<void> {
        await this.defineHeaderAxios();
        const result = await Axios.put("api/mob/settings", settings);
        if (result.status !== 200) {
            throw new Error("Unable to save MOB emergency settings.");
        }
    }

    @Action
    public async sendMobMessage(payload: {
        lat: string;
        lng: string;
        phone: string;
    }) {
        await this.defineHeaderAxios();
        Axios.post("api/mob/send/", payload)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    Log.information("Mob Sent!!");
                }
            })
            .catch((error) => {
                Log.error("", error);
            });
    }
}
